import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, hasSubscription, isTrial, trialDaysLeft, loading } = useAuth();

  console.log('ProtectedRoute: Checking state - loading:', loading, 'user:', !!user, 
    'hasSubscription:', hasSubscription, 'isTrial:', isTrial, 'trialDaysLeft:', trialDaysLeft);

  // SECURITY: Check for debug mode only in development environment
  const isDevelopment = process.env.NODE_ENV === 'development' || 
                       window.location.hostname === 'localhost' ||
                       window.location.hostname === '127.0.0.1'
  
  if (isDevelopment && localStorage.getItem('debug_mode') === 'true') {
    console.log('ProtectedRoute: Debug mode active (development only), bypassing checks');
    return <>{children}</>;
  }

  if (loading) {
    console.log('ProtectedRoute: Still loading, waiting for session/subscription');
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  // Check localStorage as a backup before redirecting
  // This prevents redirect loops during subscription checks
  const storedSubscription = localStorage.getItem('hasSubscription') === 'true';
  const storedTrial = localStorage.getItem('isTrial') === 'true';
  
  console.log('ProtectedRoute: localStorage check:', { storedSubscription, storedTrial });

  if (!user) {
    console.log('ProtectedRoute: No user, redirecting to /');
    return <Navigate to="/" replace />;
  }

  // Check for access - either subscription or active trial
  const hasAccess = hasSubscription || storedSubscription || isTrial || storedTrial;
  
  if (!hasAccess) {
    console.log('ProtectedRoute: No subscription or active trial, redirecting to pricing');
    return <Navigate to="/pricing" replace />;
  }

  console.log('ProtectedRoute: All checks passed, rendering children');
  return <>{children}</>;
};